import React from 'react';
import { Colors, ColorsType } from '../../theme';

interface IconProps {
    icon: React.ReactNode;
    color?: ColorsType;
    backgroundColor?: ColorsType;
    size?: number;
    style?: React.CSSProperties;
}

const Icon = React.forwardRef<HTMLDivElement, IconProps & React.HTMLAttributes<HTMLDivElement>>(function Icon(
    { icon, color, backgroundColor, size = 30, style, ...rest },
    ref,
) {
    return (
        <div
            ref={ref}
            {...rest}
            style={{
                color: color || Colors.secondaryMuted,
                backgroundColor: backgroundColor || Colors.secondarySoft,
                width: size,
                height: size,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: size / 2,
                aspectRatio: '1',
                flexShrink: 0,
                ...style,
            }}
        >
            {icon}
        </div>
    );
});

export default Icon;
